module.exports = __webpack_public_path__ + "static/projektmanagement-cdac4cbe58a5db33a2b2cdf595d833c7.png";